export const SANTA = '/santa';
export const IMG = '/santa/img';

/** Inline custom properties so css-loader does not try to import public files. */
export function pageBg(desk, mob) {
  return {
    '--santa-bg-desk': `url(${IMG}/${desk})`,
    '--santa-bg-mob': `url(${IMG}/${mob})`,
  };
}

export const STAGE_NEXT = {
  1: '/rounds/2',
  2: '/rounds/3',
  3: '/rounds/4',
  4: '/thank-you',
};
